const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const getAssetUrl = (key: string | null | undefined) => {
  if (!key) {
    return undefined;
  }

  return `${API_BASE_URL}/assets?key=${key}`;
};
